import { Context } from "./context";

export class DrawingContext extends Context {

}